import { LANGUAGE_CODE_EN_AU, LanguageCodes } from 'global/constants';
import { useActivityBuilderPresentContext } from 'approot/activity-builder/present/activity-builder-present.context';

/**
 * Custom hook to get the current language for draw components.
 * Returns the language from ActivityBuilderPresentContext if available,
 * or English (en-AU) if in edit/draft mode where context is not available.
 *
 * @returns The current language code or English (en-AU)
 */
export const useDrawLanguage = (): LanguageCodes => {
  const { lang } = useActivityBuilderPresentContext();
  return lang ?? LANGUAGE_CODE_EN_AU;
};
